(function() {
    module.exports = {
        loadPopUp: loadPopUp,
        loadMobileMenu: loadMobileMenu,
    }

    function loadPopUp(page, copy){
        args = copy
        $.ajax({
            url: 'templates/'+page+'.html',
            cache: false
            // dataType: "json"
        }).done(function(data) {
            $("#main-view-container").append(Mustache.render(data, args));
            $("#"+page+"-page").fadeIn();
            $(".popup-close").click(function() {
                $(this).parent().fadeOut(function(){$(this).remove()})
            })
        });
    }

    function loadMobileMenu(copy){
        args = copy
        $.ajax({
            url: 'templates/mobileMenu.html',
            cache: false
            // dataType: "json"
        }).done(function(data) {
            $("#main-view-container").append(Mustache.render(data, args));
            $("#mobile-menu-container").fadeIn();
            $("#mobile-about-btn").click(function() {
                $("#mobile-menu-container").fadeOut();
                loadPopUp('about', copy);
            })

            $("#mobile-credits-btn").click(function() {
                $("#mobile-menu-container").fadeOut();
                loadPopUp('credits', copy);
            })

            $("#stories-btn").click(function() {
                $("#mobile-menu-container").fadeOut();
            })
        });
    }
})();